<template>
    <div id="FormStep">
        <div class="form-step-container">
            <div class="title">{{ $t("newWizartV2.formStepTitle") }}</div>
            <div class="form">
                <div class="row">
                    <div>
                        <label class="display-flex">{{ $t("message.yourName") }} :</label>
                        <div class="input-wrapper">
                            <input type="text" :placeholder="$t('chatbotv2.name')" v-model="formValue.name" autocomplete="off" />
                        </div>
                    </div>

                    <div>
                        <label class="display-flex">{{ $t("settings.language") }} :</label>
                        <a-select
                            :style="{ width: '300px', height: '50px' }"
                            size="large"
                            ref="select"
                            show-search
                            placeholder="Langugage"
                            v-model="formValue.language"
                        >
                            <a-select-option v-for="lang in languages" :key="lang.code" :value="lang.code">
                                {{ lang.name }}
                            </a-select-option>
                        </a-select>
                    </div>
                </div>
                <div class="row">
                    <div>
                        <label class="display-flex">{{ $t("coupon.email") }} :</label>
                        <div class="input-wrapper">
                            <input
                                type="text"
                                disabled
                                placeholder="Email"
                                style="cursor: no-drop"
                                :value="user.email"
                            />
                        </div>
                    </div>
                    <div>
                        <label class="display-flex">{{ $t("chatbotv2.password") }} :</label>
                        <div :class="isError ? 'input-wrapper error' : 'input-wrapper'" style="display: flex">
                            <input
                                :type="isTextType ? 'text' : 'password'"
                                v-validate="'required'"
                                v-model="formValue.password"
                                :placeholder="$t('login.password')"
                            />
                            <span class="md-icon" @click="toggleInputType">visibility</span>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div>
                        <label class="display-flex">{{ $t("newWizartV2.supsisEntergation") }}</label>
                        <div id="url-input-wrapper" class="input-wrapper">
                            <span>https://</span>
                            <input
                                v-validate="{ url: { require_protocol: false } }"
                                v-model="formValue.webSiteAddress"
                                type="text"
                                name="url"
                                placeholder="example.supsis.live"
                            />
                        </div>
                    </div>
                    <div>
                        <label class="display-flex">{{ $t("message.organizationName") }} :</label>
                        <div class="input-wrapper">
                            <input v-model="formValue.organizationName" type="text" :placeholder="$t('message.organizationName')" />
                        </div>
                    </div>
                </div>
                <div class="send-button" @click="nextButtonHandler">{{ $t("newWizartV2.goToNextStep") }}</div>
            </div>
        </div>
    </div>
</template>

<script>
import { mapActions, mapState } from "vuex";
import * as _ from "lodash";
import { createScreenshot } from "../../api/screenshot";
import { sendSocketMessage } from "../../utils/socketStream";
import { getNavigatorLanguage } from "../../utils/language";
import moment from "moment/moment";

export default {
    name: "FormStep",
    data() {
        return {
            isTextType: false,
            formValue: {
                name: "",
                language: getNavigatorLanguage().code,
                email: "",
                password: "",
                webSiteAddress: "",
                organizationName: "",
            },
            isLoading: false,
            isError: false,
        };
    },
    methods: {
        ...mapActions({
            getSettings: "setting/getSettings",
            updateSettings: "setting/updateSettings",
            setSettingValue: "setting/setSettingValue",
            setLanguage: "language/setLanguage",
            updateUser: "user/updateUser",
        }),
        async nextButtonHandler() {
            this.isLoading = true;

            const { name, language, password, organizationName, webSiteAddress } = this.formValue;
            if (!password.length) {
                this.isError = true;
                this.$message.error("Password Required");
                return;
            }

            this.isError = false;
            await this.changeUserName(name);
            await this.changeOrganizationName(organizationName);
            await this.changeWebsite(this.getWebSiteAddress(webSiteAddress));
            await this.changePassword(password);
            await this.changeLanguage(language);
            this.isLoading = false;
            this.$emit("nextStep");
            /*alert(this.getWebSiteAddress(webSiteAddress))*/
        },
        applySettings(newSettings) {
            this.updateSettings(newSettings).then(() => {
                sendSocketMessage("user settings-updated", {
                    siteId: this.site._id,
                });
            });
        },
        changeUserName: _.debounce(async function (value) {
            if (!value.length) return;
            const result = this.updateUser({ ...this.user, name: value.trim() });
            result.then(() => {
                sendSocketMessage("user user-updated", {
                    userId: this.user._id,
                    siteId: this.site._id,
                });
            });
        }, 1000),
        changePassword: _.debounce(async function (value) {
            const result = this.updateUser({ ...this.user, password: value.trim() });
            result.then(() => {
                sendSocketMessage("user user-updated", {
                    userId: this.user._id,
                    siteId: this.site._id,
                });
            });
        }, 1000),
        changeOrganizationName: _.debounce(async function (value) {
            if (!value.length) return;
            const newSettings = await this.setSettingValue({
                setting: "organizationName",
                value,
            });

            this.applySettings(newSettings);
        }, 1000),
        changeWebsite: _.debounce(async function (website) {
            if (!website.length) return;
            if (this.settings.website === website) return;
            createScreenshot(website);
            const newSettings = await this.setSettingValue({
                setting: "website",
                value: website,
            });

            this.applySettings(newSettings);
        }, 1000),
        changeLanguage: _.debounce(async function (value) {
            const result = this.updateUser({ ...this.user, lang: value });
            result.then(() => {
                sendSocketMessage("user user-updated", {
                    userId: this.user._id,
                    siteId: this.site._id,
                });
            });
        }, 1000),
        toggleInputType() {
            this.isTextType = !this.isTextType;
        },
        getWebSiteAddress(address) {
            if (!address.includes("https://")) {
                return `https://${address}`;
            } else {
                return address;
            }
        },
    },

    computed: {
        ...mapState({
            settings: (state) => state.setting.settings,
            site: (state) => state.site.site,
            user: (state) => _.cloneDeep(state.auth.user),
            languages: (state) => state.language.languages,
        }),
    },
    mounted() {},
};
</script>

<style lang="scss">
#FormStep {
    width: 100%;
    height: 100%;

    .form-step-container {
        .title {
            text-align: center;
            font-size: 36px;
            font-weight: 700;
            line-height: 54px;
            font-style: normal;
            color: #1f1f1f;
        }

        .form {
            width: 75%;
            margin: 0 auto;
            text-align: center;
            position: relative;
            overflow: hidden;

            .row {
                width: 100%;
                display: flex;
                justify-content: space-around;
                margin: 0 !important;
                margin-bottom: 20px !important;
                margin-top: 50px !important;

                #url-input-wrapper {
                    display: flex;
                    align-items: center;

                    span {
                        color: #949494;
                    }
                }

                .input-wrapper {
                    width: 300px;
                    height: 50px;
                    border: 1px solid rgba(116, 116, 116, 0.29);
                    border-radius: 12px;
                    background-color: #f6f6f6;
                    padding: 10px;

                    input {
                        border: none;
                        outline: none;
                        width: 100%;
                        height: 100%;
                        background-color: transparent;

                        &:not(:last-child) {
                            margin-right: 10px;
                        }
                    }

                    &.error {
                        border: 1px solid red;
                    }
                }
            }

            .send-button {
                width: 300px;
                margin: 0 auto;
                background-color: #ec4b1d;
                padding: 10px;
                border-radius: 7px;
                align-items: center;
                font-size: 13px;
                font-weight: bold;
                color: #ffffff;
                margin-top: 60px;
                margin-bottom: 60px;
                cursor: pointer;
                user-select: none;

                &:hover {
                    background-color: #c54018;
                }
            }
        }
    }
}

.ant-select-selection {
    width: 300px !important;
    height: 50px !important;
    border: 1px solid rgba(116, 116, 116, 0.29) !important;
    border-radius: 12px !important;
    background-color: #f6f6f6 !important;

    &:hover {
        border: none !important;
        background-color: transparent;
        outline: none;
    }

    &:focus {
    }
}

.ant-select-selection-selected-value {
    margin-top: 5px !important;
}
</style>
<style lang="scss" scoped>
.display-flex {
    display: flex;
    font-weight: bold;
}

@media (max-width: 768px) {
    #FormStep .form-step-container .form {
        padding-bottom: 100px !important;
    }
    #FormStep .form-step-container .form .send-button {
        width: 75% !important;
    }
    #FormStep .form-step-container .title {
        font-size: 24px !important;
        line-height: 36px !important;
    }
    .display-flex {
        margin-top: 10px;
    }
    #FormStep .form-step-container .form {
        width: 100% !important;
    }
}
</style>
